<style scoped>
  @import "css/card-enrollment.scss";
</style>

<script>
import CardInput from '../sub-pages/card-input.vue'
import SecurityInformation from '../sub-pages/security-information.vue'
import GuestProfileInfoSave from '../../guest-profileInfo-save/guest-profileInfo-save.vue'
import Cancel from '../../cancel/cancel.vue'
import { EventBus } from '@/event-bus.js'
import { CONSTANT, CARDS_ERROR, DEFAULT_CHECKOUT_EXPERIENCE, SDK_ID_MASTERCARD, SDK_ID_VISA, SDK_ID_MAESTRO, windowRefTypes } from '@/utils/constant'
import sharedService from '@/utils/shared-service'
import checkout from '@/utils/checkout'
import { mapGetters } from 'vuex'
import { BPopover } from 'bootstrap-vue'

export default {
  name: 'Register',

  components: {
    CardInput,
    Cancel,
    SecurityInformation,
    GuestProfileInfoSave,
    BPopover
  },

  data () {
    return {
      error: '',
      showCancel: '',
      isCardValid: true,
      cardBrand: '',
      visaCard: SDK_ID_VISA,
      isGuestProfileInfoVisible: false,
      isRememberMeVisible: true

    }
  },

  computed: {
    ...mapGetters(['selectedCheckoutExperience', 'payloadRequested', 'authPreference', 'enableMPT', 'profileOptOut', 'isConsumerAuthModuleEnable', 'windowRefType']),
    rememberMe: {
      get () {
        return this.$store.getters.rememberMe
      },
      set (value) {
        if (window.opener && window.opener.childSrcWindow) {
          window.opener.postMessage({ rememberMe: value })
        }
        this.$store.dispatch('updateRememberMeConsent', value)
      }
    }
  },
  created () {
    this.showCancel = window.opener
    this.setInitaiateState()
  },

  mounted () {
    EventBus.$on('handleError', (event) => {
      this.error = event
      setTimeout(() => {
        this.error = ''
      }, 3000)
    })
  },

  methods: {

    setInitaiateState () {
      if (this.enableMPT) {
        this.isRememberMeVisible = !this.enableMPT
        this.isGuestProfileInfoVisible = !this.enableMPT
      }
      this.$store.dispatch('updateProfileOptOut', false)
    },

    getCardBrand (value) {
      let network = value.length > 0 ? value[0] : ''
      if (network === SDK_ID_MAESTRO) {
        this.cardBrand = SDK_ID_MASTERCARD
      } else {
        this.cardBrand = network
      }

      if (this.cardBrand && this.cardBrand === SDK_ID_MASTERCARD) {
        this.$store.dispatch('updateProfileOptOut', false)
        this.isGuestProfileInfoVisible = true
        this.isRememberMeVisible = false
        return
      }
      if (this.cardBrand && this.cardBrand === SDK_ID_VISA) {
        this.$store.dispatch('updateProfileOptOut', true)
        this.isGuestProfileInfoVisible = true
        this.isRememberMeVisible = true
        return
      }

      if (this.cardBrand) {
        this.isRememberMeVisible = true
      } else {
        this.isRememberMeVisible = false
      }

      this.$store.dispatch('updateProfileOptOut', false)
      this.isGuestProfileInfoVisible = false
    },

    getGuestProfileInfo (value) {
      this.isRememberMeVisible = value
    },

    loginPage () {
      sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.LOGIN_SCREEN, this.$router)
    },

    /**
     * This method create the user details object
     */
    getUserDetails () {
      return {
        primaryAccountNumber: sharedService.unmask(this.$refs.cardNumber.cardNumber),
        panExpirationMonth: this.$refs.securityInfo.expiry.split('/')[0],
        panExpirationYear: '20' + this.$refs.securityInfo.expiry.split('/')[1],
        cardSecurityCode: this.$refs.securityInfo.cvc2,
        network: this.$refs.cardNumber.cardType,
        ...(this.enableMPT && this.$refs.cardNumber.cardType === 'mastercard') && {
          profileOptOut: this.profileOptOut
        }
      }
    },

    /**
     * This method is use to invoke popup experince.
     */
    invokePopup () {
      if (!window.opener) {
        sharedService.invokeSrc(false, CONSTANT.SRC.INLINE_CARD, this.$store)
      }
    },

    /**
     * This method is use to set window Reference(popup,actionsheet/iframe)for DCF.
     */
    setWindowReference (cardDetail) {
      if (this.isConsumerAuthModuleEnable && this.windowRefType === windowRefTypes.ACTION_SHEET) {
        this.$store.dispatch('lightBoxloaderOn', true)
        this.$parent.$refs.authenticationIframe.addEventListener('load', () => {
          this.$store.dispatch('lightBoxloaderOn', false)
          EventBus.$emit('visibleActionsheet', false)
        })
        window.checkoutIframeRef = this.$parent.$refs.authenticationIframe.contentWindow
      } else {
        this.$store.dispatch('lightBoxloaderOn', true)
        let isIframe = true
        const isDefaultExperiance = this.selectedCheckoutExperience !== DEFAULT_CHECKOUT_EXPERIENCE
        const isiFramePFL = this.isConsumerAuthModuleEnable && this.windowRefType === windowRefTypes.IFRAME
        if (this.authPreference && cardDetail.network === 'mastercard' && sharedService.checkFeatureFlag('START_LMC_CHANGES')) {
          isIframe = !(this.payloadRequested === 'AUTHENTICATED')
        }
        if ((isiFramePFL || isDefaultExperiance) && isIframe) {
          this.$refs.cardNumber.$refs.iframe.addEventListener('load', () => {
            this.$store.dispatch('lightBoxloaderOn', false)
            this.$store.commit('checkoutProgress', true)
            this.$refs.cardNumber.$refs.iframeContainer.classList.add('show')
          })
          this.$refs.cardNumber.$refs.iframeBackground.addEventListener('click', () => {
            this.$store.commit('checkoutProgress', false)
          })
          window.checkoutIframeRef = this.$refs.cardNumber.$refs.iframe.contentWindow
        } else {
          this.invokePopup()
        }
      }
    },

    /**
     * This method calls the enrollCard api
     * @returns {Promise<void>}
     */
    async enrollCard () {
      this.$store.commit('updateNewUser', true)
      try {
        setTimeout(() => {
          this.$store.dispatch('lightBoxloaderOn', false)
        }, 8000)
        let cardDetail = this.getUserDetails()
        this.isCardValid = sharedService.validateCardDetails(cardDetail)
        if (this.isCardValid) {
          this.setWindowReference(cardDetail)
          let windowRef = !window.opener ? checkout : window.opener.checkout
          await windowRef.initiate({
            cardDetail,
            enrollCard: true
          }).catch(error => {
            this.$store.dispatch('lightBoxloaderOn', false)
            console.log(error)
            this.error = CARDS_ERROR
            EventBus.$emit('handleError', this.error)
          })
        } else {
          this.$store.dispatch('lightBoxloaderOn', false)
          this.error = 'CARD_DETAIL_INVALID'
          EventBus.$emit('handleError', this.error)
        }
      } catch (error) {
        this.$store.dispatch('lightBoxloaderOn', false)
        this.error = error.errors[0].reason
        EventBus.$emit('handleError', this.error)
      }
    }
  }
}
</script>

<template>
  <div id="register">
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert"
    >
      {{ $t('errorMessages.' +error) }}
    </div>
    <card-input
      ref="cardNumber"
      @cardBrand="getCardBrand"
    />
    <security-information
      ref="securityInfo"
    />
    <div>
      <div v-if="isGuestProfileInfoVisible">
        <guest-profileInfo-save
          :card-brand="cardBrand"
          @input="getGuestProfileInfo"/>
      </div>
      <div v-if="isRememberMeVisible">
        <div
          class="form-check rm-checkbox text-left">
          <input
            id="remember-me"
            v-model="rememberMe"
            class="form-check-input rm-input"
            type="checkbox">
          <label
            class="form-check-label rm-label"
            for="remember-me-cookie">
            <strong> {{ $t ('label.rememberMeBrowser') }}</strong>
          </label>
          <i
            id="popover-target"
            class="fa fa-info-circle info-pad"
            aria-hidden="true"/>
          <b-popover
            target="popover-target"
            triggers="hover"
            placement="bottom">
            When remembered, you’ll skip verification <br>and securely access your saved cards<br> when paying with Click to Pay.
            <br><br>Not recommended for public or shared <br> devices
            because this uses cookies.
          </b-popover>
        </div>
        <div class="mt-3">
          <div
            class="col-full"
            data-test="consent"
            value="true">
            <p
              data-test="legal-footnote"
              class="legal">By continuing, you agree to <span v-if="cardBrand !== visaCard">Mastercard’s</span><span v-if="cardBrand===visaCard">Visa's</span>  <a
                class="link-color"
                href="https://www.mastercard.com/global/click-to-pay/en-us/terms-of-use.html"
                data-test="create-terms-button"
                target="_blank"
                place="termsAndConditions"> Terms</a> and understand your data will be processed according to the <a
                  class="link-color"
                  href="https://www.mastercard.com/global/click-to-pay/en-us/privacy-notice.html"
                  data-test="create-privacy-button"
                  target="_blank"
                  place="privacyPolicy">Privacy Notice</a>.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center">
      <small class="text-center">
        {{ $t ('cardEnrollment.footerText') }}
      </small>
      <button
        id="get-started-btn"
        class="btn btn-dark btn-lg mt-2 lightbox-btn"
        data-test="btn-continue"
        type="submit"
        @click="enrollCard()"
      >
        {{ $t ('cardEnrollment.getStarted') }}
      </button>
      <div
        id="login-link"
        class="mt-3 cursor-pointer font-weight-bold font15"
        @click="loginPage()"
      >
        {{ $t ('cardEnrollment.signInUser') }}
      </div>
      <cancel
        v-if="showCancel"
        class="mt-3"
      />
    </div>
  </div>
</template>
